<div class="row">
    <div class="col-2 text-primary display-2">404</div>
    <div class="col justify-content-center align-self-center ps-5">
      {{ 'ERROR_MSG.STATUS_404' | translate }}
    </div>
</div>
  